import dannyProfile from "../../assets/Images/Artists/DANNY.jpg";
import img1 from "../../assets/Images/Artwork/Danny/danny1.jpg";
import img2 from "../../assets/Images/Artwork/Danny/danny2.jpg";
import img3 from "../../assets/Images/Artwork/Danny/danny3.jpg";
import img4 from "../../assets/Images/Artwork/Danny/danny4.jpg";
import alanProfile from "../../assets/Images/Artists/ALAN.jpg";
import alan_img1 from "../../assets/Images/Artwork/Alan/alan1.jpg";
import alan_img2 from "../../assets/Images/Artwork/Alan/alan2.jpg";
import alan_img3 from "../../assets/Images/Artwork/Alan/alan3.jpg";
import alan_img4 from "../../assets/Images/Artwork/Alan/alan4.jpg";
import antoProfile from "../../assets/Images/Artists/ANTO.jpg";
import anto_img1 from "../../assets/Images/Artwork/Anto/anto1.jpg";
import anto_img2 from "../../assets/Images/Artwork/Anto/anto2.jpg";
import anto_img3 from "../../assets/Images/Artwork/Anto/anto3.jpg";
import anto_img4 from "../../assets/Images/Artwork/Anto/anto4.jpg";
import leeProfile from "../../assets/Images/Artists/LEE.jpg";
import lee_img1 from "../../assets/Images/Artwork/Lee/lee1.jpg";
import lee_img2 from "../../assets/Images/Artwork/Lee/lee2.jpg";
import lee_img3 from "../../assets/Images/Artwork/Lee/lee3.jpg";
import lee_img4 from "../../assets/Images/Artwork/Lee/lee4.jpg";
import khangProfile from "../../assets/Images/Artists/KHANG.jpg";
import khang_img1 from "../../assets/Images/Artwork/Khang/khang1.jpg";
import khang_img2 from "../../assets/Images/Artwork/Khang/khang2.jpg";
import khang_img3 from "../../assets/Images/Artwork/Khang/khang3.jpg";
import khang_img4 from "../../assets/Images/Artwork/Khang/khang4.jpg";
import tuProfile from "../../assets/Images/Artists/TU.jpg";
import tu_img1 from "../../assets/Images/Artwork/Tu/tu1.jpg";
import tu_img2 from "../../assets/Images/Artwork/Tu/tu2.jpg";
import tu_img3 from "../../assets/Images/Artwork/Tu/tu3.jpg";
import tu_img4 from "../../assets/Images/Artwork/Tu/tu4.jpg";
import megProfile from "../../assets/Images/Artists/MEG.jpg";
import meg_img1 from "../../assets/Images/Artwork/Meg/meg1.jpg";
import meg_img2 from "../../assets/Images/Artwork/Meg/meg2.jpg";
import meg_img3 from "../../assets/Images/Artwork/Meg/meg3.jpg";
import meg_img4 from "../../assets/Images/Artwork/Meg/meg4.jpg";
import chauProfile from "../../assets/Images/Artists/CHAU.jpg";
import chau_img1 from "../../assets/Images/Artwork/Chau/chau1.jpg";
import chau_img2 from "../../assets/Images/Artwork/Chau/chau2.jpg";
import chau_img3 from "../../assets/Images/Artwork/Chau/chau3.jpg";
import chau_img4 from "../../assets/Images/Artwork/Chau/chau4.jpg";
import yinProfile from "../../assets/Images/Artists/YIN.jpg";
import yin_img1 from "../../assets/Images/Artwork/Yin/yin1.jpg";
import yin_img2 from "../../assets/Images/Artwork/Yin/yin2.jpg";
import yin_img3 from "../../assets/Images/Artwork/Yin/yin3.jpg";
import yin_img4 from "../../assets/Images/Artwork/Yin/yin4.jpg";
import shaylaProfile from "../../assets/Images/Artists/SHAYLA.jpg";
import shayla_img1 from "../../assets/Images/Artwork/Shayla/shayla1.jpg";
import shayla_img2 from "../../assets/Images/Artwork/Shayla/shayla2.jpg";
import shayla_img3 from "../../assets/Images/Artwork/Shayla/shayla3.jpg";
import shayla_img4 from "../../assets/Images/Artwork/Shayla/shayla4.jpg";
import devilsProfile from "../../assets/Images/Artists/DEVILS.jpg";
import devils_img1 from "../../assets/Images/Artwork/Devils/devils1.jpg";
import devils_img2 from "../../assets/Images/Artwork/Devils/devils2.jpg";
import devils_img3 from "../../assets/Images/Artwork/Devils/devils3.jpg";
import devils_img4 from "../../assets/Images/Artwork/Devils/devils4.jpg";
import karlProfile from "../../assets/Images/Artists/KARL.jpg";
import karl_img1 from "../../assets/Images/Artwork/Karl/karl1.jpg";
import karl_img2 from "../../assets/Images/Artwork/Karl/karl2.jpg";
import karl_img3 from "../../assets/Images/Artwork/Karl/karl3.jpg";
import karl_img4 from "../../assets/Images/Artwork/Karl/karl4.jpg";
import nellProfile from "../../assets/Images/Artists/NELL.jpg";
import nell_img1 from "../../assets/Images/Artwork/Nell/nell1.jpg";
import nell_img2 from "../../assets/Images/Artwork/Nell/nell2.jpg";
import nell_img3 from "../../assets/Images/Artwork/Nell/nell3.jpg";
import nell_img4 from "../../assets/Images/Artwork/Nell/nell4.jpg";
import alexProfile from "../../assets/Images/Artists/ALEX.jpg";
import alex_img1 from "../../assets/Images/Artwork/Alex/alex1.jpg";
import alex_img2 from "../../assets/Images/Artwork/Alex/alex2.jpg";
import alex_img3 from "../../assets/Images/Artwork/Alex/alex3.jpg";
import alex_img4 from "../../assets/Images/Artwork/Alex/alex4.jpg";

// import woojinProfile from "../../assets/Images/Artists/WOOJIN.jpg";
// import woojin_img1 from "../../assets/Images/Artwork/Woojin/woojin1.jpg";
// import woojin_img2 from "../../assets/Images/Artwork/Woojin/woojin2.jpg";
// import woojin_img3 from "../../assets/Images/Artwork/Woojin/woojin3.jpg";
// import woojin_img4 from "../../assets/Images/Artwork/Woojin/woojin4.jpg";
// {
//   image: woojinProfile,
//   name: "WOOJIN",
//   licence: "",
//description:
//     "Woojin, a remarkable tattoo artist, embarked on his transformative journey in 2016 as an apprentice under the esteemed Hocheon family at New Flame Ink Studio in Korea, where he imbibed the essence of the craft and kindled his passion for tattooing. Specializing in the intricate finesse of NEO Japanese style, Woojin's artistry seamlessly weaves contemporary innovation with the rich tapestry of Japanese tradition, resulting in mesmerizing inked masterpieces.",
//   gallery: [woojin_img1, woojin_img2, woojin_img3, woojin_img4],
//   social: "https://www.instagram.com/woojin.tattooer/",
// },

const artistsData = [
  {
    image: dannyProfile,
    name: "DANNY",
    licence: "102814",
    description:
      "Danny, a visionary tattoo artist and owner, embarked on his creative journey in 2010, specializing in the intricate realms of realism and oriental design, particularly excelling in black and grey tattoos. As the founder and owner of his tattoo studio, Danny has cultivated a haven where creativity knows no bounds, solidifying his place as a luminary in the tattooing world. His artistry extends beyond the studio, gracing galleries and exhibitions, further cementing his legacy as a true artist of innovation and dedication in the realm of tattooing.",
    gallery: [img1, img2, img3, img4],
    social: "https://www.instagram.com/dannytruongtattoo/",
  },
  {
    image: alanProfile,
    name: "ALAN",
    licence: "101845",
    description:
      "Alan’s professional tattooing career started in 2016 within a busy street shop allowing him to proficiently cater to all styles. Alan’s array of influences come from his love of Oriental art - from Tibetan Buddhist art to Japanese ukiyo-e woodblock prints. Alan specializes in large scale pieces inspired by traditional Japanese Irezumi with intricate detail in full color or black and grey. Alan also doesn’t shy away from smaller one-shot tattoos!",
    gallery: [alan_img1, alan_img2, alan_img3, alan_img4],
    social: "https://www.instagram.com/alan_blackjadetattoo/",
  },
  {
    image: antoProfile,
    name: "ANTO",
    licence: "109126",
    description:
      "Anto specializes in Japanese oriental - add: he has been mastering his style since 2016. Taking inspiration through his life, Japanese Culture and Buddhism; he curates meaningful and unique pieces for each of his clients. Anto also has experience tattooing color, realism, mandala and custom scripts. He prides himself with his capabilities to do an awesome cover up through oriental Japanese.",
    gallery: [anto_img1, anto_img2, anto_img3, anto_img4],
    social: "https://www.instagram.com/anto_ghostkoi/",
  },
  {
    image: leeProfile,
    name: "LEE",
    licence: "101356",
    description:
      "Lee has been tattooing since 2011, he is a color tattooist also dabbling in black and grey work. His bubbly person with a more than life personality.",
    gallery: [lee_img1, lee_img2, lee_img3, lee_img4],
    social: "https://www.instagram.com/deadleeink/",
  },
  {
    image: khangProfile,
    name: "KHANG",
    licence: "106021",
    description:
      "Khang has been drawing since young customizing his own oriental art. After years of circling around different career fields, he is finally doing what he is passionate about and landing himself an apprenticeship with Black Jade Tattoo in early 2020. Khang is an all-rounder who specializes in Oriental/Traditional Japanese, Chicano, Realism and custom script. Trust his process and join his journey.",
    gallery: [khang_img1, khang_img2, khang_img3, khang_img4],
    social: "https://www.instagram.com/khangfu_/",
  },
  {
    image: tuProfile,
    name: "TU",
    licence: "105805",
    description:
      "Tu’s passion for art started at a very young age – she studied Fine Arts at UNSW and landed herself a tattoo apprenticeship at Black Jade Tattoo in 2020. She specializes in fine line tattoos and enjoys doing custom animal and floral designs. Follow her tattoo journey as our newest and upcoming artist.",
    gallery: [tu_img1, tu_img2, tu_img3, tu_img4],
    social: "https://www.instagram.com/tu_tattooist/",
  },
  {
    image: megProfile,
    name: "MEG",
    licence: "106606",
    description:
      "Meg has had a passion for art since before she can remember. Her work is unique yet inspired by her Japanese cultural roots - having spent the first 16 years of her life in Japan. Before stepping into the tattoo industry, Meg gained professional experience within the graphic design sector, diversifying her range and ability. Having started her apprenticeship at Black Jade in 2021 she is a fresh face that is eager to hone her craft with other talented artists.",
    gallery: [meg_img1, meg_img2, meg_img3, meg_img4],
    social: "https://www.instagram.com/gumi.tattoos/",
  },
  {
    image: chauProfile,
    name: "CHAU",
    licence: "107044",
    description:
      "Chau has been creative all her life, from learning oil painting during primary school, drawing Anime inspired artworks through high school, completing an Advance Diploma in illustration in TAFE to now launching herself into her dream career as a tattoo artist, starting as an apprentice at Black Jade Tattoo. She specialises in black and line work and enjoys creating dark-femme inspired pieces. Her passion and dedication to her craft stimulates unique and thought provoking pieces.",
    gallery: [chau_img1, chau_img2, chau_img3, chau_img4],
    social: "https://www.instagram.com/inkedbychau/",
  },
  {
    image: yinProfile,
    name: "YIN",
    licence: "107161",
    description:
      "Yins passion for art has translated into her love for tattooing. She specializes in illustrative fineline work that has a whimsical and dreamy essence and she enjoys doing floral, decorative and ornamental designs. Follow her journey as an up and coming artist at Blackjade tattoo.",
    gallery: [yin_img1, yin_img2, yin_img3, yin_img4],
    social: "https://www.instagram.com/inkbyyink/",
  },
  {
    image: shaylaProfile,
    name: "SHAYLA",
    licence: "107623",
    description:
      "Meet Shayla, a budding tattoo apprentice artist who embarked on her creative voyage in 2023, wielding a remarkable talent for illustration and fine line art. With a passion for translating intricate visions onto the canvas of human skin, Shayla's work shines through her precise detailing and captivating designs. Guided by experienced mentors in her studio, she's honing her skills to create art that adds new dimensions to the world of modern tattooing.",
    gallery: [shayla_img1, shayla_img2, shayla_img3, shayla_img4],
    social: "https://www.instagram.com/shayyl.aink/",
  },
  {
    image: devilsProfile,
    name: "DEVILS",
    licence: "108781",
    description:
      "Meet Devils, our apprentice tattoo artist, a dynamic creative spirit whose journey began in the vibrant world of street art before seamlessly transitioning into the realm of tattooing. With an unwavering passion for self-expression, Devils' evolution has been nothing short of awe-inspiring. In 2023, they found his true calling in the art of custom script tattoos, where words and emotions intertwine to create personalized masterpieces.",
    gallery: [devils_img1, devils_img2, devils_img3, devils_img4],
    social: "https://www.instagram.com/devilsinker/",
  },
  {
    image: karlProfile,
    name: "KARL",
    licence: "107884",
    description: [
      "Karl is a passionate and aspiring new apprentice in Black Jade. Drawing inspiration from the mesmerizing world of ukiyo-e woodblock prints, his art aims to elebrate the beauty of traditional Japanese culture blended with a modern twist. Influenced by artists such as Ichibay, Filip Leu, Mike Dorsey, and Horiyoshi 3 to name a few.",
      " He strive's to create unique and meaningful tattoos that tell stories and leave a lasting impression. Join him on this artistic journey as we explore the fusion of history and innovation in the world of tattoos.",
    ],
    gallery: [karl_img1, karl_img2, karl_img3, karl_img4],
    social: "https://www.instagram.com/lag_man__/",
  },
  {
    image: nellProfile,
    name: "NELL",
    licence: "107548",
    description:
      "Nell has been tattooing since 2022. She also has an extensive background in digital illustration and honed her skills at Enmore Design school. She specialises in fine line, custom abstract and suminagashi black work tattoos. Bubbly and down to earth personality.",
    gallery: [nell_img1, nell_img2, nell_img3, nell_img4],
    social: "https://www.instagram.com/inkednell/",
  },
  {
    image: alexProfile,
    name: "ALEX",
    licence: "107623",
    description:
      "Alex is a rising talent in the tattoo world, having embarked on his career in 2022. Specializing in the bold and dramatic blackwork style, he brings a unique perspective to his craft. Alex's expertise lies in merging blackwork with surrealistic, dark, and oriental themes, creating captivating and thought-provoking pieces. His work is deeply rooted in realistic techniques, allowing him to seamlessly transition between styles and push the boundaries of his art. With a keen eye for detail and a passion for innovation, Alex is a versatile and skilled tattooist capable of bringing his clients' most imaginative ideas to life.",
    gallery: [alex_img1, alex_img2, alex_img3, alex_img4],
    social: "https://www.instagram.com/33BLK/",
  },
];

export default artistsData;
